export const AUTHENTICATED = 'AUTHENTICATED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';

export const MANAGER_APPROVAL_SUCCESS = 'MANAGER_APPROVAL_SUCCESS';
export const MANAGER_APPROVAL_FAILURE = 'MANAGER_APPROVAL_FAILURE';

export const ADD_MANAGER_APPROVAL_SUCCESS = 'ADD_MANAGER_APPROVAL_SUCCESS';
export const ADD_MANAGER_APPROVAL_FAILURE = 'ADD_MANAGER_APPROVAL_FAILURE';

export const GET_PROPERTY_MANAGERS_SUCCESS = 'GET_PROPERTY_MANAGERS_SUCCESS';
export const GET_PROPERTY_MANAGERS_FAILURE = 'GET_PROPERTY_MANAGERS_FAILURE';

export const GET_PROPERTY_MANAGER_PROPERTY_SUCCESS = 'GET_PROPERTY_MANAGER_PROPERTY_SUCCESS';
export const GET_PROPERTY_MANAGER_PROPERTY_FAILURE = 'GET_PROPERTY_MANAGER_PROPERTY_FAILURE';

export const GET_PROPERTYS_SUCCESS = 'GET_PROPERTYS_SUCCESS';
export const GET_PROPERTYS_FAILURE = 'GET_PROPERTYS_FAILURE';

export const GET_TENANTS_SUCCESS = 'GET_TENANTS_SUCCESS';
export const GET_TENANTS_FAILURE = 'GET_TENANTS_FAILURE';

export const EMAIL_TEMPLATES_SUCCESS = 'EMAIL_TEMPLATES_SUCCESS';
export const EMAIL_TEMPLATES_FAILURE = 'EMAIL_TEMPLATES_FAILURE';

export const NEW_CAMPAIGN_SUCCESS = 'NEW_CAMPAIGN_SUCCESS';
export const NEW_CAMPAIGN_FAILURE = 'NEW_CAMPAIGN_FAILURE';

export const GET_DEFAULT_TEMPLATE_SUCCESS = 'GET_DEFAULT_TEMPLATE_SUCCESS';
export const GET_DEFAULT_TEMPLATE_FAILURE = 'GET_DEFAULT_TEMPLATE_FAILURE';

export const GET_GL_ACCOUNT_SUCCESS = 'GET_GL_ACCOUNT_SUCCESS';
export const GET_GL_ACCOUNT_FAILURE = 'GET_GL_ACCOUNT_FAILURE';

export const INVOICE_DATA_SUCCESS = 'INVOICE_DATA_SUCCESS';
export const INVOICE_DATA_FAILURE = 'INVOICE_DATA_FAILURE';

export const CLEAR_COIS_DATA_SUCCESS = 'CLEAR_COIS_DATA_SUCCESS';

export const COIS_DATA_SUCCESS = 'COIS_DATA_SUCCESS';
export const COIS_DATA_FAILURE = 'COIS_DATA_FAILURE';

export const GET_APPROVAL_DOC_SUCCESS = 'GET_APPROVAL_DOC_SUCCESS';
export const GET_APPROVAL_DOC_FAILURE = 'GET_APPROVAL_DOC_FAILURE';

export const UPDATE_EMAIL_SETTING_SUCCESS = 'UPDATE_EMAIL_SETTING_SUCCESS';
export const UPDATE_MANAGER_APPROVAL_SUCCESS = 'UPDATE_MANAGER_APPROVAL_SUCCESS';

export const GET_GL_ACC_SUCCESS = 'GET_GL_ACC_SUCCESS';
export const GET_GL_ACC_FAILURE = 'GET_GL_ACC_FAILURE';

export const GET_PAST_INVOICE_SUCCESS = 'GET_PAST_INVOICE_SUCCESS';
export const GET_PAST_INVOICE_FAILURE = 'GET_PAST_INVOICE_FAILURE';

export const GET_COIS_UPLOADED_FILES_SUCCESS = 'GET_COIS_UPLOADED_FILES_SUCCESS';
export const GET_COIS_UPLOADED_FILES_FAILURE = 'GET_COIS_UPLOADED_FILES_FAILURE';

export const GET_SINGLE_PAST_INVOICE_SUCCESS = 'GET_SINGLE_PAST_INVOICE_SUCCESS';

export const PENDING = 'PENDING';
export const ERRORS = 'ERRORS';



// WEBPACK FOOTER //
// ./src/actions/types.ts